import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../../ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../../Util/axiosErrorHandler'
import { IAPICurrentUser, ICurrentUser } from '../interface/ICurrentUser'
import { currentUserTransformer } from '../transformer/currentUserTransformer'

export const fetchCurrentUser = createAsyncThunk<
  ICurrentUser,
  {},
  IThunkReject<any>
>('currentUser/fetch', async (_, { rejectWithValue }) => {
  let apiData: IAPICurrentUser | null = null

  try {
    const promise = clientSDK
      .instance()
      .get<{ data: IAPICurrentUser }>('person')
    const result = await promise
    apiData = result.data.data
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return currentUserTransformer(apiData)
})
